import React from 'react';

const GuestIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Head */}
      <circle cx="10" cy="6" r="4" fill="currentColor" />
      {/* Shoulders */}
      <path
        d="M4 16C4 12 16 12 16 16"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.4"
      />
    </svg>
  );
};

export default GuestIcon;
